import { Badge } from '../Badge';
import { QrCode } from '../../types/badge';
import { QrCodeTypes } from '../../types/enums';
import BadgeUtils from '../utils/badgeUtils';

export class BadgeQRCode {
  static async getQrCodeSrc(qrCode: QrCode) {
    let finalSrc = qrCode.src;
    if (qrCode.type === QrCodeTypes.URL) {
      const base64QrCode = await this.fetchQrCodeAsBase64(qrCode.src);
      if (!base64QrCode) {
        throw new Error('No qr code presented');
      }
      finalSrc = base64QrCode;
    }

    return finalSrc;
  }

  static async fetchQrCodeAsBase64(qrCodeUrl: string) {
    try {
      const fetchQrCodeImage = (await fetch(qrCodeUrl)) as Response & { _bodyBlob: Blob };
      if (BadgeUtils.findAllowedTypeInContentType(fetchQrCodeImage.headers.get('content-type')!)) {
        return await Badge.blobToBase64(await fetchQrCodeImage.blob());
      }
      return null;
    } catch (e) {
      console.error(e);
      return null;
    }
  }
}
